__webpack_require__.p = "https://torpedo-assets-live.s3.ap-southeast-1.amazonaws.com/admin/20260313_111117/";